import BemIt, { addClass } from "@gtechdoodler/bem-it";
import TextInputContainer from "../TextInputContainer";
import { StyledTextField } from "./TextField.styles";
import { TextFieldProps } from "./TextField.types";

const TextField: React.FC<TextFieldProps> = ({
	className,
	disableUpDownArrowKeys,
	onKeyDown,
	...props
}) => {
	const block = new BemIt("TextField");

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "ArrowDown" || event.key === "ArrowUp") {
			event.preventDefault();
		}
		// But... still need to bubble the event
		if (onKeyDown) {
			onKeyDown(event);
		}
	};

	return (
		<TextInputContainer className={addClass(className).after(block)} {...props}>
			<StyledTextField type="text" onKeyDown={handleKeyDown} />
		</TextInputContainer>
	);
};

export default TextField;
